module.exports = __webpack_public_path__ + "static/media/19 April _ logo placement changes_ Banner 4.b0c7c896.png";